import {
  useRef, useEffect, useState, useContext,
} from 'react';

import cn from 'classnames/bind';
import throttle from 'lodash-es/throttle';
import PropTypes from 'prop-types';
import { Context as LayoutContext } from 'ui/containers/LayoutContext';

import s from './StickyElement.module.scss';

const cx = cn.bind(s);

const StickyElement = ({ children, className, ...attrs }) => {
  const { getHeaderHeight } = useContext(LayoutContext);
  const wrapperRef = useRef(null);
  const stickyRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  const [wrapperDimensions, setWrapperDimensions] = useState({ width: 0, left: 0 });
  const [stickyTopOffset, setStickyTopOffset] = useState(false);
  useEffect(() => {
    const onScroll = throttle(() => {
      const topOffset = wrapperRef.current?.getBoundingClientRect()?.top - getHeaderHeight?.();
      setStickyTopOffset(topOffset <= 0 ? getHeaderHeight?.() : null);
    }, 20);
    const onResize = throttle(() => {
      if (stickyRef.current) {
        setContentHeight(stickyRef.current.offsetHeight);
      }
      if (wrapperRef.current) {
        setWrapperDimensions({
          left: wrapperRef.current.getBoundingClientRect().left,
          width: wrapperRef.current.offsetWidth,
        });
      }
    }, 50);
    onResize();
    onScroll();
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, [getHeaderHeight]);
  return (
    <div
      ref={wrapperRef}
      className={cx(className, 'wrapper')}
      {...attrs}
      style={{
        height: contentHeight ? `${contentHeight}px` : null,
      }}
    >
      <div
        className={cx('stickyContainer', {
          stickyContainerActive: !!stickyTopOffset,
        })}
        style={{
          top: stickyTopOffset ? `${stickyTopOffset}px` : null,
          '--left-offset': wrapperDimensions.left ? `${wrapperDimensions.left}px` : null,
        }}
      >
        <div
          ref={stickyRef}
          className={cx('sticky')}
          style={{
            width: wrapperDimensions.width ? `${wrapperDimensions.width}px` : null,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

StickyElement.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default StickyElement;
